import { useMutation, useQuery } from "@tanstack/react-query";
import { QuestionDto } from "../../../services/dto";
import { IActionResponse, IActionResult } from "../../../assets/utils/lib";
import { LookupDto } from "../../../assets/utils/lib/lookupDto";
import { QuestionClient } from "../../../services/proxies/questionnaire/questionClient";
import { SearchDto } from "../../../assets/utils/lib/searchDto";

export namespace QuestionService {
  const questionClient = new QuestionClient();

  export const save = () =>
    useMutation<IActionResult<QuestionDto>, Error, QuestionDto>({
      mutationFn: async (payload: QuestionDto) => {
        return await questionClient.saveQuestionAsync(payload);
      },
    });

  export const getQuestionQuery = (questionId: string | undefined) =>
    useQuery({
      queryKey: ["questionQuery", questionId],
      queryFn: async () => await questionClient.getQuestionAsync(questionId),
      enabled: Boolean(questionId),
    });

  export const deActivateQuestion = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (communityId: string | undefined) => {
        return await questionClient.deActivateQuestionAsync(communityId);
      },
    });
  export const deleteQuestion = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await questionClient.deleteQuestionAsync(id);
      },
    });

  export const gridQuery = (searchQuery?: SearchDto) =>
    useQuery({
      queryKey: ["questionnaireQuestionGridQuery", searchQuery],
      queryFn: async () =>
        await questionClient.searchQuestionsAsync(searchQuery),
    });

  export const getLookups = (questionnaireId?: string | undefined) =>
    useQuery({
      queryKey: ["questionLookupsQuery"],
      queryFn: async () => await questionClient.getLookupsAsync(questionnaireId),
      enabled: Boolean(questionnaireId),
      select: (data) => {
        return {
          questionType: LookupDto.mapToOptions(data?.questionTypes),
          sections: LookupDto.mapToOptions(data?.sections),
        };
      },
    });
}
